import type { ReactNode } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

interface SiteLayoutProps {
  children: ReactNode;
  overlayHeader?: boolean;
}

export default function SiteLayout({ children, overlayHeader = false }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader overlay={overlayHeader} />
      <main className={`flex-1 ${overlayHeader ? "" : "pt-16 md:pt-20"}`}>{children}</main>
      <SiteFooter />
    </div>
  );
}